import { ListingActionButtons } from 'components/Listing/ListingActionButtons';
import { useListingsContext } from '../../state/listings';
import styled from 'styled-components';
import { Listing, ListingItem } from '../../components';
import { ListingInfoPanel } from '../../components/Listing/ListingInfoPanel';
import { getStatusIcon } from '../../components/Listing/utils';

const ListingsSectionContainer = styled.section`
  display: flex;
  flex-direction: column;

  > * + * {
    margin-top: ${({ theme }) => theme.spacings[5].rem};
  }
`;

export type ListingsSectionProps = {
  listings: ListingItem[];
};

export const ListingsSection: React.FC<ListingsSectionProps> = ({
  listings,
}) => {
  const {
    handlers: { setModalContent, promote, review, auctionData },
  } = useListingsContext();
  return (
    <ListingsSectionContainer>
      {listings.map((listing) => (
        <Listing
          key={listing.id}
          onReferredInfoModal={setModalContent}
          actionButtonContent={
            <ListingActionButtons
              actions={listing.actions}
              onReview={() => review(listing)}
              onPromote={() => promote(listing)}
              onLowerReserve={setModalContent}
              onAcceptBid={setModalContent}
              onHoldReserve={setModalContent}
            />
          }
          infoPanelContent={
            listing.statusData && (
              <ListingInfoPanel
                action={listing.statusData}
                onViewPaymentDetails={setModalContent}
                titleIcon={getStatusIcon({
                  state: listing.auctionState,
                  type: listing.statusData.type,
                })}
              />
            )
          }
          onAuctionDataClick={auctionData}
          {...listing}
        />
      ))}
    </ListingsSectionContainer>
  );
};
